var path = 'app/scripts/modules/amazon/src/serverGroup/configure/wizard/advancedSettings/advancedSettings.html';
var html = "<div class=\"clearfix\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <aws-server-group-advanced-settings command=\"command\" application=\"application\"></aws-server-group-advanced-settings>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/configure/wizard/advancedSettings/advancedSettings.html
// module id = 1238
// module chunks = 0